/**
 *  Filename ....: search-medications.component.ts
 *  Created by ..: ianday
 *  on Date .....: 4/14/25
 **/
import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {DwUtils} from '../../../components/utils/dw-utils';
import {MedSearchStructure} from '../../../models/med-search-structure';

@Component({
    selector: 'app-search-medications',
    templateUrl: './search-medications.component.html',
    styleUrls: ['./search-medications.component.css']
})

export class SearchMedicationsComponent implements OnInit{

    public strErr = '';
    public enableSubmit = false;
    public ndcNumber: string;
    public medDescription: string;

    public _callFrom: string = '';

    @Output() cancelClicked = new EventEmitter();
    @Output() submitClicked = new EventEmitter<any>();

    @Input() set callFrom(inp: string) {
        this._callFrom = inp;
    }
    constructor() {
        this.resetFields();
    }

    @HostListener ('keydown', ['$event.target'])
    onKeyDownGlobal(event) {
        this.strErr = '';
        this.enterPressed(event);
    }

    ngOnInit() {
        this.showDialogFocus();
    }

    public showDialogFocus(): void {
        if (this._callFrom === 'medications') {
            DwUtils.setFocus('ndcNumber');
        }
        else {
            DwUtils.setFocus('medDescription');
        }
    }
    public enterPressed(event: KeyboardEvent): void {

        if ((event.key === 'Enter') && (this.enableSubmit === true)) {
            this.onSubmitClicked();
        }
    }
    public resetFields(): void {
        this.ndcNumber = '';
        this.medDescription = '';
        DwUtils.setFocus('ndcNumber');
    }
    public fieldChange(ev: Event): void {
        if ((this.ndcNumber.length > 0) || ( this.medDescription.length > 0)) {
            this.enableSubmit = true;
        }
        else {
            this.enableSubmit = false;
        }
    }
    public onSubmitClicked(): void {
        const s = new MedSearchStructure(this.ndcNumber,  this.medDescription.toUpperCase());
        this.submitClicked.emit(s);
    }
    public onCancelClicked(): void {
        this.cancelClicked.emit();
    }
}


